import { extend, merge, trimEnd } from 'lodash';

export default function createRequest({ baseUrl = '', instance = '', locale = 'en', cookie } = {}) {
  const request = (path, config = {}) => {
    const url = `${trimEnd(baseUrl, '/')}${path}`;
    const shouldParseHeaders = config.parseHeaders;

    delete config.parseHeaders;

    const headers = {
      ...config.headers,
      instance,
      locale,
    };
    if (cookie) {
      headers.cookie = cookie;
    }

    extend(config, {
      headers,
      credentials: 'same-origin',
    });

    const promise = fetch(url, config).then(handleSuccess);

    return promise.then(shouldParseHeaders ? parseHeadersAndBody : parseBody);
  };

  request.post = (path, data, config) => {
    return request(
      path,
      merge({}, config, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
    );
  };

  request.put = (path, data, config) => {
    return request(
      path,
      merge({}, config, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
    );
  };

  request.patch = (path, data, config) => {
    return request(
      path,
      merge({}, config, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
    );
  };

  request.delete = (path, config) => {
    return request(
      path,
      extend({}, config, {
        method: 'DELETE',
      })
    );
  };

  request.uploadFile = (file, credentials) => {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('media_type', 'picture');
    formData.append('upload_token', credentials.uploadToken);
    formData.append('parent_folder_id', credentials.folderId);

    const config = {
      method: 'POST',
      body: formData,
    };

    return fetch(credentials.uploadUrl, config).then(handleSuccess).then(parseBody);
  };

  return request;
}

function handleSuccess(response) {
  const status = response.status;

  if (status < 400) {
    return response;
  }

  return Promise.reject(response);
}

function parseBody(response) {
  return response.json().catch(() => Promise.resolve());
}

function parseHeadersAndBody(response) {
  return response
    .json()
    .then(data => ({
      body: data,
      headers: response.headers,
    }))
    .catch(() => Promise.resolve());
}



// WEBPACK FOOTER //
// ./app/services/create-request.js